export default __webpack_public_path__ + "static/media/arrorTopDark.334b82c9.svg";